import { Knock } from "@knocklabs/node";
import { Grants } from "@knocklabs/node/dist/src/common/userTokens";
import { config } from "~/config";
import { type AppContext } from "~/lib/context";
import { logError, logWarn } from "~/lib/logger";

export const generateKnockUserTokenForAuthenticatedUser = async (ctx: AppContext) => {
  if (!ctx.user) {
    logWarn(ctx, "[knock] Could not generate knock user token because user is not authenticated");
    return null;
  }

  if (!config.knock.signingKey) {
    logError(ctx, "[knock] Signing key is not set");
    return null;
  }

  try {
    return await Knock.signUserToken(ctx.user.id.toString(), {
      signingKey: config.knock.signingKey,
      grants: [
        Knock.buildUserTokenGrant({ type: "tenant", id: ctx.user.company.id.toString() }, [
          Grants.SlackChannelsRead,
          Grants.MsTeamsChannelsRead,
        ]),
      ],
    });
  } catch (error) {
    logError(ctx, "[knock] Could not generate knock user token", { error });
    return null;
  }
};
